import { Grid, Typography } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { IKeypadModal, KeypadModal } from 'src/common/components/keypad-modal/keypad-modal';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import { PromotionApprovalProps } from './promotion-approval';
import { styles } from './promotion-approval-quantity-picker-styles';

export const PromotionApprovalQuantityModal = ({
  approvalMessage,
  resolvePromotion,
  pendingRedemptionCount,
}: PromotionApprovalProps): JSX.Element => {
  const classes = styles();
  const PROMOTION_APPROVAL_INPUT_INSTRUCTIONS: string = 'Typically 1 digit';
  const [isInvalid, setIsInvalid] = useState<boolean>(false);
  const { t } = useTranslation();

  const onCancel = (): void => {
    resolvePromotion({ isApproved: false, authorizedCount: 0 });
    popEmeraldModal();
  };

  const onSubmit = (keyedValue: string): void => {
    if (
      Number.isInteger(Number(keyedValue)) &&
      Number(keyedValue) > 0 &&
      Number(keyedValue) <= pendingRedemptionCount
    ) {
      resolvePromotion({ isApproved: true, authorizedCount: Number(keyedValue) });
      popEmeraldModal();
    } else {
      setIsInvalid(true);
    }
  };

  const keypadSubmitButton: IButton = {
    label: t('PromotionApproval_Apply'),
    onClick: onSubmit,
  };

  const keypadModal: IKeypadModal = {
    onClose: onCancel,
    title: 'PromotionApproval_Caption',
    buttonComponent: (
      <Grid item className={classes.bottom}>
        <BaseButton buttonType='white' data-testid='promotion-approval-cancel' onClick={onCancel}>
          <span className={classes.cancelLabel}>{t('Cancel_Button')}</span>
        </BaseButton>
      </Grid>
    ),
    contentArea: (
      <Grid className={classes.innerContainer}>
        <Grid item>
          {isInvalid && (
            <Grid container direction='row' className={classes.errorContainer}>
              <ReportProblemOutlinedIcon classes={{ root: `${classes.icon}` }} />
              <Grid className={classes.errorMessage} data-testid='invalid-quantity-error'>
                {t('PromotionApproval_PickQuantity', {
                  arg: pendingRedemptionCount.toString(),
                })}
              </Grid>
            </Grid>
          )}
          <Typography className={classes.instructionTitle}>{t('PointsRedemption')}</Typography>
          <Typography
            data-testid='promotion-approval-message'
            className={classes.instructionMessage}
          >
            {t('PromotionApproval_CustomerMultiplePromotionMessage', {
              arg: pendingRedemptionCount.toString(),
              arg2: approvalMessage,
            })}
          </Typography>
        </Grid>
      </Grid>
    ),
    keypad: (
      <Keypad
        initialInputValue={pendingRedemptionCount.toString()}
        visible={true}
        inputInstructionsLabelText={PROMOTION_APPROVAL_INPUT_INSTRUCTIONS}
        keypadTestIdPrefix={'promotion-approval-'}
        submitButton={keypadSubmitButton}
      />
    ),
  };
  return <KeypadModal {...keypadModal} />;
};
